import type { State as CompanyState } from '@/pages/CompanyReport/redux/interface';
import type { LocationState } from 'redux-first-router';
import { shallowEqual, useSelector } from 'react-redux';
import { makeGetCompanyBreadcrumbs } from '@/pages/CompanyReport/redux/selectors';
import { pathConstructor } from './utils';

type Selected =
  | { status: 'loading' }
  | {
      status: 'success';
      breadcrumbs: ReturnType<ReturnType<typeof makeGetCompanyBreadcrumbs>>;
    };
export function useBreadcrumbs() {
  const selected = useSelector(
    (state: { location: LocationState; company: CompanyState }): Selected => {
      const path = pathConstructor(state.location);
      const companyId = state.company.urlToIdMapping[path];
      if (companyId === '' || typeof companyId === 'undefined')
        return { status: 'loading' };
      const getCompanyBreadcrumbs = makeGetCompanyBreadcrumbs(true);
      const breadcrumbs = getCompanyBreadcrumbs(state, { companyId });
      return { status: 'success', breadcrumbs };
    },
    shallowEqual
  );
  return selected;
}
